<template>
    <v-card class="customer-card">
        <data-view
            v-if="customer.is_company"
            :title="getProperty('company_name') || getProperty('email')"
            :subtitle="$t('steps.summary.company')"
            icon="mdi-account-tie"
            :items="customerData">
        </data-view>
        <data-view
            v-else
            :title="fullName || getProperty('email')"
            :subtitle="$t('steps.summary.private')"
            icon="mdi-account"
            :items="customerData">
        </data-view>
    </v-card>
</template>

<script>
    import DataView from "@/components/data/DataView";

    export default {
        name: "Customer",
        props: ['customer'],
        components: {DataView},
        computed: {
            fullName() {
                return (this.getProperty('first_name') + " " + this.getProperty('last_name')).trim()
            },
            customerData() {
                let data = [
                    {
                        label: this.$t('steps.customer.email'),
                        value: this.getProperty('email')
                    },
                    {
                        label: this.$t('steps.customer.phone'),
                        value: this.getProperty('phone')
                    },
                    {
                        label: this.$t('steps.customer.street'),
                        value: this.getProperty('street') + " " + this.getProperty('house') + ((this.getProperty('apartment').trim() != "") ? "/" + this.getProperty('apartment') : '')
                    },
                    {
                        label: this.$t('steps.customer.city'),
                        value: (this.getProperty('postal').trim() != "") ? this.getProperty('postal') + ", " + this.getProperty('city') : this.getProperty('city')
                    }
                ]
                if (this.customer.is_company) {
                    data.unshift({
                        label: this.$t('steps.customer.nip'),
                        value: this.getProperty('nip')
                    })
                }
                return data
            }
        },
        methods: {
            getProperty(prop) {
                return this.customer.hasOwnProperty(prop) && this.customer[prop] != null ? this.customer[prop] : ''
            }
        }
    }
</script>

<style scoped>
    .customer-card {
        width: max-content;
    }
</style>
